export const MatrixConstants = {
    IDENTIY_MATRIX: [
        [1, 0, 0, 0],
        [0, 1, 0, 0],
        [0, 0, 1, 0],
        [0, 0, 0, 1],
    ]
};
